import { MDBCol, MDBLightbox, MDBLightboxItem, MDBRow } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React from 'react';
import { renderDescriptions } from '../utils/Common';
import Details from './Details';
import './gallery.css';

function GalleryComponent({ item, createCart, weight, setWeight, qty, setQty, reviews }) {
  if (!item) return null;

  const images = item?.thumbnails?.map((thumbnail, index) => ({
    src: thumbnail,
    fullscreenSrc: item.imageIds[index],
    alt: `Gallery image ${index + 1}`,
  }));

  const [firstDescription, ...remainingDescriptions] = item?.descriptions || [];

 
 

  return (
    <>
      {/* Row with the first image and item details */}
      <MDBRow className='justify-content-center mt-2'>
        <MDBCol xs='12' sm='6' md='6' lg='6' xl='6' className='d-flex justify-content-center'>
          {/* MDBLightbox to handle all images */}
          <MDBLightbox>
            {/* First image full size */}
            {images && images.length > 0 && (
              <MDBLightboxItem
                className="first-image rounded"
                src={images[0].fullscreenSrc}
                thumbnail={images[0].fullscreenSrc}
                alt={images[0].alt}
                style={{ cursor: 'pointer', width: '100%' }} // Full size first image
              />
            )}
            {/* Second image onwards displayed as icons/thumbnails */}
            {images && images.length > 1 && (
              <div className='thumbnail-row d-flex justify-content-start mt-2'>
                {images.slice(1).map((img, index) => (
                  <MDBLightboxItem
                    key={index + 1}
                    className="small-image me-1 rounded"
                    src={img.fullscreenSrc}
                    thumbnail={img.fullscreenSrc}
                    alt={img.alt}
                    style={{ width: '60px', height: '60px', cursor: 'pointer' }} // Small images
                  />
                ))}
              </div>
            )}
          </MDBLightbox>
        </MDBCol>

        <MDBCol xs='12' sm='6' md='6' lg='6' xl='6'>
          {/* Rendering the Details component */}
          <Details
            item={item}
            createCart={createCart}
            weight={weight}
            setWeight={setWeight}
            qty={qty}
            setQty={setQty}
            reviews={reviews}
            firstDescription={firstDescription}
          />
        </MDBCol>
      </MDBRow>

      {/* Remaining descriptions below the gallery and details */}
      {remainingDescriptions.length > 0 && (
        <MDBRow className='justify-content-center mt-3 '>
          <MDBCol xs='12'>
            {renderDescriptions(remainingDescriptions)}
          </MDBCol>
        </MDBRow>
      )}
    </>
  );
}

GalleryComponent.propTypes = {
  item: PropTypes.object,
  createCart: PropTypes.func,
  weight: PropTypes.string,
  setWeight: PropTypes.func,
  qty: PropTypes.string,
  setQty: PropTypes.func,
  reviews: PropTypes.object,
};

export default GalleryComponent;
